import getVideoId from 'get-video-id';

/**
 * Parses a video url to convert it to embed format.
 *
 * @param   {string} src  The original url.
 * @returns {string} url  The converted url.
 */
export default (src) => {

	if (!src) {
		return src;
	}

	let url = src;

	const videoInfo = getVideoId(src);

	if (videoInfo && (videoInfo.service === 'youtube' || videoInfo.service === 'vimeo')) {

		url = 'https://';

		if (videoInfo.service === 'youtube') {
			url += 'www.youtube.com/embed/';
		} else if (videoInfo.service === 'vimeo') {
			url += 'player.vimeo.com/video/';
		}

		url += videoInfo.id;

	}

	return url;

};
